import { isEqual } from "lodash";
import { ErrorDescription } from "../../types/handled_error";

const handledErrors: ErrorDescription[] = [
  {
    endpoint: "signup",
    method: "post",
    responseStatus: 422,
    error: "email_already_exists",
  },
  {
    endpoint: "confirmation",
    method: "get",
    responseStatus: 422,
    error: "invalid_confirmation_token",
  },
  {
    endpoint: "password",
    method: "post",
    responseStatus: 422,
    error: "email_does_not_exist",
  },
];

export const isHandled = (error: ErrorDescription): boolean =>
  !!handledErrors.find(
    (handledError: ErrorDescription) =>
      ((typeof handledError.endpoint === "string" &&
        handledError.endpoint === error.endpoint) ||
        (handledError.endpoint instanceof RegExp &&
          handledError.endpoint.test(error.endpoint as string))) &&
      handledError.method === error.method &&
      handledError.responseStatus === error.responseStatus &&
      isEqual(handledError.error, error.error)
  );
